import { Typography } from "@mui/material";
import React, { useState } from "react";
import config from "../../../../../config";
import { IconAttachment } from "../../../../../utils/icons";
import { Button } from "../../../../../components/Button/Button";
import { IEmbed } from "../../embedsV2/interface";

interface Props {
  embed: IEmbed;
  openSettings: () => void;
}

export function EmbedCodePanel({ embed, openSettings }: Props) {
  const [isCopied, setIsCopied] = useState<boolean>();

  const formatName = (name: any) => name?.replace(/\s+/g, "-").toLowerCase();
  const formatSettings = (source: string, preview = false) => {
    let previewString = "";
    if (preview) previewString = "&preview=true";
    const settingsString = `?source=${source}${previewString}`;
    return settingsString;
  };

  const formatEmbedCode = (human: boolean = false) => {
    const vH = `&lt;script class=&quot;tdc2&quot; bid=&quot;${embed.brand_id}&quot; eid=&quot;${embed.id}&quot; type=&quot;text/javascript&quot; src=&quot;${config.EMBED_HOST}/assets/js/e2.js&quot;&gt;&lt;/script&gt;`;
    const vC = `<script class="tdc2" bid="${embed.brand_id}" eid="${
      embed.id
    }" b="${embed?.brand?.slug}" e="${formatName(
      embed.name
    )}" type="text/javascript" src="${
      config.EMBED_HOST
    }/assets/js/e2.js${formatSettings("embed")}"></script>`;
    return human ? vH : vC;
  };

  const onCopyBtnClick = () => {
    navigator.clipboard.writeText(formatEmbedCode());
    setIsCopied(true);
    setTimeout(setIsCopied, 2000);
  };

  return (
    <div className="flex flex-col gap-2 justify-between h-full">
      <div className="p-6 flex flex-col w-full gap-4">
        <div className="p-4 bg-surface-2 rounded-md">
          <code>{formatEmbedCode()}</code>
        </div>
      </div>
      <div className="pt-4 flex items-center justify-end px-6 border-t border-border-token">
        <Button
          className="!flex gap-1 !px-4 items-center justify-center"
          onClick={onCopyBtnClick}
        >
          <Typography>{isCopied ? "Copied!" : "Copy Embed Code"}</Typography>
          <IconAttachment stroke="#fff" />
        </Button>
      </div>
    </div>
  );
}
